module.exports = __webpack_public_path__ + "static/media/dot_vertical.b116969f.svg";